import common from '@page/common/js/common';
import siteCtrl from '@page/common/js/siteCtrl';
import cartLib from '@global/components/cart/cartLib';

siteCtrl.corpPage();
